export default __webpack_public_path__ + "static/media/FICHA TÉCNICA - LIMÃO SICILIANO.33867d49.pdf";